import { Component, Inject, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LessonCard } from '../../../interfaces/lesson-card.interface';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { AuthService } from '../../../services/auth.service';
import { ApiV2Service } from '../../../services/api-v2.service';
import { SpinnerService } from '../../../services/spinner.service';
import { ActivityCard } from '../../../interfaces/activity-card.interface';
import { ActivityInfo } from '../../../interfaces/activity-info.interface';
import { CourseCard } from '../../../interfaces/course-card.interface';
import { Organization } from '../../../interfaces/organization-info.interface';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-dialog-grade-course',
  templateUrl: './dialog-grade-course.component.html',
  styleUrls: ['./dialog-grade-course.component.css']
})
export class DialogGradeCourseComponent implements OnInit {
  gradeCourseForm: FormGroup;
  courseId: number;
  lessonId: number;
  actualLesson: any;
  coursesId:any[] = [];


  courses: CourseCard[] = [];
  allCourses: CourseCard[] = [];
  filteredCourses: Observable<CourseCard[]>;
  removedCourses: CourseCard[] = [];

  icons: any = {
    success: { icon: 'check_circle' },
    info: { icon: 'info' },
    danger: { icon: 'error' },
    warning: { icon: 'warning' },
    question: { icon: 'help' }
  }

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('courseInput') courseInput: ElementRef<HTMLInputElement>;
  message: any;
  router: any;
  @ViewChild('select') private select: MatSelect;

  constructor(
    private api: ApiV2Service,
    private spinner: SpinnerService,
    //private router: Router,
    //private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private auth: AuthService,
    private dialogRef: MatDialogRef<DialogGradeCourseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.gradeCourseForm = new FormGroup({
      courses: new FormControl(null)
    });
  }

  ngOnInit(): void {
    // this.gradeCourseForm.valueChanges.subscribe(() => {
    //   this.ref.markForCheck();
    // });
    const organizations: Organization = this.auth.currentMainOrganization;
    this.getCoursesByOrganization({ organization: organizations.id, limit: 1000000 });
    //console.log(this.data.messageLessonId);
    this.gradeCourseForm.get('courses').valueChanges.subscribe(() => {
      this.select.close();
    });
  }



  getCoursesByOrganization(params?: any) {
    //this.spinner.showSpinner = true;
    this.api.getService('GET_COURSES_BY_ORGANIZATION', params).pipe(map((data) => {
      return data['results'];
    })).subscribe(
      (courses: CourseCard[] | any[]) => {
        this.allCourses = [...this.allCourses, ...courses];
        this.filteredCourses = this.gradeCourseForm.get('courses').valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value, this.allCourses)));
        console.log(this.allCourses);
        this.getActualLessonCard();
      },
      (error) => {
        console.log('Error:', error);
        this.spinner.showSpinner = false;
      }
    );
  }

  getActualLessonCard() {
    //this.spinner.showSpinner = true;
    this.api.getAlternativeService('GET_LESSON_BY_ID', this.data.messageLessonId).pipe(map((data) => {
      data['courses'] = data['profile_groups'] ? this.allCourses.filter(item => data['profile_groups'].includes(item.id)) : []
      data['color'] = '#00AFB4';
      data['isPublic'] = data['is_public'];
      data['isInstalled'] = data['is_installed'];
      delete data['is_public'];
      delete data['is_installed'];
      return data;
    })).subscribe(
      (lesson: LessonCard) => {
        //const valueCategory: Category = this.categories.find((category) => { category.name === lesson.category });
        this.gradeCourseForm.get('courses').setValue(null);
        this.courses = lesson.courses;
        this.actualLesson = {
          courses: JSON.parse(JSON.stringify(lesson.courses))
        };
        this.gradeCourseForm.setValue(this.actualLesson);
        this.gradeCourseForm.get('courses').setValue(this.courses);
        console.log(lesson, this.actualLesson);
        this.spinner.showSpinner = false;
      },
      (error) => {
        console.log('Error: ', error);
        this.spinner.showSpinner = false;
      });
  }

  private _filter(value: any, options: any[]): any[] {
    console.log('filter value',value)
    //console.log('filter value.name',value.name.toLowerCase())
    const filterValue = value && value.name ? value.name.toLowerCase() : value;
    console.log('filtervalue',filterValue)
    console.log('options',options)
    return options.filter(option => option.name.toLowerCase().includes(filterValue) ? option.name : '');
  }

  addCourse(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (event.input) {
      event.input.value = '';
     }
    this.gradeCourseForm.get('courses').setValue('');
  }

  removeCourse(course: CourseCard): void {
    const index = this.courses.indexOf(course);
    const index2=this.coursesId.indexOf(course)
    if(index==-1){
      const lesssons = this.gradeCourseForm.get('courses').value;
      this.removeFirst(lesssons, course);
      this.gradeCourseForm.get('courses').setValue(lesssons); // To trigger change detection
    
    }
    else{
      this.removeLessonToCourse(course.id)
      const lesssons = this.gradeCourseForm.get('courses').value;
      this.removeFirst(lesssons, course);
      this.gradeCourseForm.get('courses').setValue(lesssons); // To trigger change detection
    
      // if (index >= 0) {
      //   console.log('REMOVE', course.id, index);
      //   this.courses.splice(index, 1);
      //   this.coursesId.splice(index, 1);
      //   console.log('remove',this.coursesId)
      // }
    }
    
  }
  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  courseSelected(event: MatAutocompleteSelectedEvent): void {
    console.log('SELECTED', event);
    console.log('SELECTED', event.option.value);
    this.courses.push(event.option.value);
    console.log('courses',this.courses.map((item: CourseCard) => item.id))
    this.coursesId=this.courses.map((item: CourseCard) => item.id)
    console.log("coursesid",this.coursesId)
    this.courseInput.nativeElement.value = '';
    this.gradeCourseForm.get('courses').setValue('');
  }

  public closeMe() {
    this.dialogRef.close();
  }

  removeLessonToCourse(courseId: string) {
    const body = {
      grades: [this.data.messageLessonId]
    }
    this.api.postAlternativeService('REMOVE_LESSONS_TO_COURSE', body, courseId).subscribe(
      (data) => {
        console.log(data);
        this.spinner.showSpinner = false;
      },
      (error) => {
        console.log('Error: ', error);
        this.spinner.showSpinner = false;
      }
    );
  }

  sendto(){
    if(this.gradeCourseForm.get('courses').value!=null||this.gradeCourseForm.get('courses').value!=undefined){
      this.filteredCourses = this.gradeCourseForm.get('courses').valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value, this.allCourses)));
            console.log("estos son ",this.coursesId)
    console.log()
    this.coursesId=this.gradeCourseForm.get('courses').value.map((item:CourseCard)=>item.id)
    return this.coursesId
    }
    
    //return this.gradeCourseForm.get('courses').value
  }

}